import { XMLValidator } from 'fast-xml-parser'

export function XMLStringIsWellFormed(string) {
    return XMLValidator.validate(`<pseudo-tag>${string}</pseudo-tag>`) === true ? true : false
}
